import { createFileRoute } from "@tanstack/react-router";

import { SupportChat } from "@/components/support-chat";

export const Route = createFileRoute("/ho-tro")({
  head: () => ({
    meta: [
      { title: "Hỗ Trợ Trực Tuyến - Chat Với Trợ Lý Bói Đê" },
      {
        name: "description",
        content:
          "Trò chuyện trực tuyến với Trợ lý Bói Đê để được hỗ trợ về tài khoản, thanh toán và cách sử dụng.",
      },
      { property: "og:title", content: "Hỗ Trợ Trực Tuyến - Chat Với Trợ Lý Bói Đê" },
      {
        property: "og:description",
        content: "Hỏi nhanh về tài khoản, dịch vụ, thanh toán hoặc cách sử dụng Bói Đê.",
      },
      { property: "og:url", content: "https://boide.online/ho-tro" },
    ],
    links: [{ rel: "canonical", href: "https://boide.online/ho-tro" }],
  }),
  component: SupportChat,
});
